import classNames from 'classnames'
import { useEffect } from 'react'

import i18n from 'i18n'
import { confirmBase } from 'utils/ui'

import MaintenanceFrame from './MaintenanceFrame'
import styles from './style.module.scss'
import useI18nReady from './useI18nReady'

interface ForceUpdateModalProps {
  url: string
  lang?: string
}

/**
 * 강제 업데이트 모달. confirmBase 로 표시(공지와 동일 팝업 디자인).
 * - 새로고침 1버튼만 렌더(footer 에서 OkBtn 만 노출 → cancel 버튼 DOM 자체를 제거해 우회 차단).
 * - 닫기/mask/ESC 모두 불가(강제). 명령형 모달이므로 mount 시 생성, unmount 시 destroy.
 */
function ForceUpdateModal({ url, lang }: ForceUpdateModalProps): null {
  const { ready: i18nReady, revision: i18nRevision } = useI18nReady()

  useEffect(() => {
    if (!i18nReady) return undefined

    const modal = confirmBase({
      className: classNames('mobile-fullpage'),
      closable: false,
      maskClosable: false,
      keyboard: false,
      content: (
        <div className={styles.modalContent} data-testid="maintenance-force-update">
          <MaintenanceFrame
            url={url}
            title={i18n.t('maintenance.forceUpdateTitle')}
            lang={lang}
            className={styles.modalFrame}
          />
        </div>
      ),
      okText: i18n.t('common.button.refresh'),
      okButtonProps: { 'data-testid': 'maintenance-force-update-refresh' },
      footer: (_, { OkBtn }) => <OkBtn />,
      onOk: () => window.location.reload(),
    })

    return () => modal.destroy()
  }, [url, lang, i18nReady, i18nRevision])

  return null
}

export default ForceUpdateModal
